<template>
    <div>
        <div class='has-text-centered'>
            <croppa ref="myCroppa"
                :width="width"
                :height="height"
                :canvas-color="'default'"
                :placeholder="'Choose an image'"
                :placeholder-font-size="0"
                :placeholder-color="'default'"
                :accept="'image/*'"
                :file-size-limit="0"
                :quality="2"
                :zoom-speed="3"
                :disabled="false"
                :disable-rotation="true"
                :prevent-white-space="true"
                :reverse-scroll-to-zoom="false"
                :show-remove-button="true"
                :remove-button-color="'black'"
                :remove-button-size="0"
            ></croppa>
        </div>

        <span class='is-pulled-left'>
            <ol id='image-instructions'>
                <li>Slide the image to move it</li>
                <li>Scroll or pinch to zoom</li>
            </ol>
        </span>

        <span class='is-pulled-right'>
            <b-button type="is-primary" icon-left="upload" @click='uploadImage()' :loading="isUploading">
                Upload
            </b-button>

            <a class='button' @click="clearImage()">
                <b-icon icon="refresh"></b-icon>
                <span>Clear</span>
            </a>
        </span>
    </div>
</template>

<style scoped>
#image-instructions {
    margin-left: 30px;
    font-size: 0.9em;
}
</style>

<script>
export default {
  name: 'Cropper',
  props: ['context', 'width', 'height'],
  data() {
    return {
        isUploading: false
    }
  },
  methods: {
    clearImage: function() {
      this.$refs.myCroppa.remove();
    },
    uploadImage: function() {
        var that = this;
        this.isUploading = true;
        this.$refs.myCroppa.generateBlob(function(blob) {
            if(!blob) { // no file selected

            }
            else {
                let data = new FormData();
                data.append('image', blob);

                // `context` can't be appended to FormData... thinking because of Sails' bodyParser; so put in query instead
                that.$http.post(that.$hostname + '/upload?context=' + that.$props.context, data).then(function(response) {
                    that.$emit('uploadSuccess', response.body); // response.body is an Image record
                }, function(error) {
                    that.$emit('uploadFailure', error);
                }).finally(function() {
                    // Wait a bit before letting the Upload button be clicked again,
                    // because otherwise the user can click the upload button quickly
                    // before the cropper component is closed
                    window.setTimeout(() => {
                        this.isUploading = false;
                    }, 1000)
                });
            }
        }, 'image/jpeg', 0.80);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Cropper.vue